import React, { memo } from 'react'
import { TableCell } from '../ui/Table'
import { pluralize } from '../../utils/textHelpers'

const CELL_MAX_WIDTH = { maxWidth: '250px' }

const buildFilterUrl = (baseUrl, variableId, value) => {
  const params = new URLSearchParams()
  params.set('variable_id', variableId)
  params.set('variable_value', value || '')
  return `${baseUrl}?${params}`
}

const VariableCell = ({ row, filterUrl, variableId }) => (
  <TableCell className="text-truncate" style={CELL_MAX_WIDTH} title={row.value || ''}>
    {row.value || <em className="text-muted">Vide</em>}
    {typeof row.answerCount === 'number' && (
      <div className="small text-muted d-flex align-items-center">
        {pluralize(row.answerCount, 'contrôle')}
        {filterUrl && variableId ? (
          <a
            className="text-muted ml-1"
            href={buildFilterUrl(filterUrl, variableId, row.value)}
            rel="noopener noreferrer"
            target="_blank"
            title="Voir les ressources"
          >
            <i className="fas fa-eye" />
          </a>
        ) : null}
      </div>
    )}
  </TableCell>
)

export default memo(VariableCell)
